import { FunctionComponent, useState, useEffect } from "react";

type Part =
  | {
      type: "text";
      text: string;
    }
  | {
      type: "link";
      link: string;
      text: string;
    };

function processText(text: string) {
  const parts = [] as Part[];
  const UrlReg =
    /https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)/gi;
  let match = UrlReg.exec(text);
  let lastIndex = 0;
  while (match) {
    if (match.index > lastIndex) {
      parts.push({
        type: "text",
        text: text.slice(lastIndex, match.index),
      });
      lastIndex = match.index;
    }
    const url = match[0];
    lastIndex += url.length;
    parts.push({
      type: "link",
      link: url,
      text: new URL(url).host,
    });
    match = UrlReg.exec(text);
  }
  if (text.slice(lastIndex)) {
    parts.push({
      type: "text",
      text: text.slice(lastIndex),
    });
  }
  return parts;
}

const RichText: FunctionComponent<{
  text?: string;
  className?: string;
}> = function ({ text, className }) {
  const [parts, setParts] = useState<Part[]>([]);

  useEffect(() => {
    setParts(processText(text || ""));
  }, [text]);
  return (
    <div className={`${className}`}>
      {parts.map((part, index) => {
        if (part.type === "text") {
          return <span key={index}>{part.text}</span>;
        } else if (part.type === "link") {
          return (
            <a
              href={part.link}
              className="action !text-primary "
              target="_blank"
              key={index}
              rel="noreferrer"
            >
              {part.text}
            </a>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
};

export default RichText;
